import Component from '../../common/Component';
import SlideShow from '../../common/components/SlideShow';
import app from '../app';


export default class Footer extends Component {

  oninit(vnode) {
    super.oninit(vnode);
    this.mobileImgList = [];
    this.webImgList = []
    this.getImageListData();
    this.getTopImageListData();
  }
  view() {
    return <div class='footer-content'>
      {/* <img src="/assets/image/top-banner.png" class="foot-banner web" /> */}
      {this.getWebBottom()}
      {this.getMobileBottom()}
      {/* <img src="/assets/image/footer.png" class='web' /> */}
      <div class="footer-contact-container">
        {/* <div class="footer-contact-item">
          <img src="/assets/image/wechat.svg" class='foot-icon' />
          <div class='footer-contact-inner-container'>
            <div class="footer-contact-text">客服微信号<br />rencaiphmy</div>
            <div class="footer-contact-text">猎头微信号<br />rencaiph</div>
          </div>
        </div> */}
        <div class="footer-contact-item">
          <img src="/assets/image/telegram.svg" class='foot-icon' />
          <div class='footer-contact-inner-container'>
            <div class="footer-contact-text" onclick={this.openUrl.bind(this, 'https://t.me/rencaiphmy/')}>客服飞机号<br />rencaiphmy</div>
            <div class="footer-contact-text" onclick={this.openUrl.bind(this, 'https://t.me/rencaiph/')}>猎头飞机号<br />rencaiph</div>
          </div>
        </div>
        <div class="footer-contact-item">
          <img src="/assets/image/phoneno.svg" class='foot-icon' />
          <div class='footer-contact-inner-container'>
            <div class="footer-contact-text">客服手机号<br />+6011-11456936</div>
            <div class="footer-contact-text">猎头手机号<br />+6011-11204862</div>
          </div>
        </div>
        <div class="web">
          <div class="footer-contact-item footer-qr-box">
            <div class='footer-qr-item'>
              <img src="/assets/image/WhatsApp(601111456936).jpg" class='qr-icon' />
              <div class='footer-contact-text'>客服WhatApp</div>
            </div>
            <div class='footer-qr-item'>
              <img src="/assets/image/WhatsApp(601111204862).jpg" class='qr-icon' />
              <div class='footer-contact-text'>猎头WhatsApp</div>
            </div>
            <div class='footer-qr-item'>
              <img src="/assets/image/Rencai-TG-Qr.jpg" class='qr-icon' />
              <div class='footer-contact-text'> 官方飞机群</div>
            </div>
          </div>
        </div>
      </div>
      <div class='foot-text'>Copyright © 2022 人才.ph by 亚特兰蒂斯科技公司</div>
    </div>;
  }

  getMobileBottom() {
    if (this.mobileImgList.length == 0) return null;
    return (<div class='bottom_banner_container mobile'>
      <SlideShow slideName="bottom_banner1" containerId="bottom_banner1" imgList={this.mobileImgList} slideWidth={0} autoWidth={true}>
      </SlideShow>
    </div>);
  }
  getWebBottom() {
    if (this.webImgList.length == 0) return null;
    return (<div class='bottom_banner_container web'>
      <SlideShow slideName="bottom_banner" containerId="bottom_banner" imgList={this.webImgList} slideWidth={0} autoWidth={true}>
      </SlideShow>
    </div>);
  }

  items() {
    const items = new ItemList();
    return items;
  }

  getImageListData() {
    let data = app.adsbannerData;
    if (data) {
      let list = data.list.banner['mobile_forum_ad_2'];
      if (list) {
        this.mobileImgList = list;
      }
    }
  }

  getTopImageListData() {
    let data = app.adsbannerData;
    if (data) {
      let list = [];
      list = data.list.banner['forum_banner'];

      if (list) {
        this.webImgList = list;
      }
    }
  }

  openUrl(link) {
    if (link != "")
      window.open(link);
  }

}
